import React from 'react';

// @ts-ignore
import Icon from 'assets/images/trojanSvg/mice-red-75.svg';

const MiceIcon_3: React.FC = () => {
  return <img src={Icon} height={16} alt="Mice amount 3 Icon" />;
};

export default MiceIcon_3;
